// extracted by mini-css-extract-plugin
export var content = "FaqBody-module--content--81f24";
export var heading = "FaqBody-module--heading--da81e";